<template>
  <ion-page class="bg-white" >
    <ion-router-outlet/>
  </ion-page>
</template>

<script setup lang="ts">
import { IonPage, IonRouterOutlet } from '@ionic/vue';
</script>
